import type { FC } from "react";
import RecentSearchChip from "./RecentSearchChip";

type Props = {
  title?: string;
  terms: string[];
  onRemove: (term: string) => void;
  onSelect: (term: string) => void;
};

const RecentSearches: FC<Props> = ({ title, terms, onRemove, onSelect }) => (
  <div className="flex flex-wrap gap-2">
    {title && <h3 className="text-xl font-semibold w-full">{title}</h3>}
    {terms.map((term) => (
      <RecentSearchChip
        key={term}
        term={term}
        onRemove={onRemove}
        onSelect={onSelect}
      />
    ))}
  </div>
);

export default RecentSearches;
